import { useEffect } from 'react';
import i18n from 'i18next';

import { useUrlParams } from './useUrlParams';

export const useLanguageInitializer = (): void => {
  const { language } = useUrlParams();

  useEffect(() => {
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language).catch((error) => {
        console.warn(`Failed to change language to ${language}:`, error);
        i18n.changeLanguage('en');
      });
    }
  }, [language]);
};
